import React, { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import styles from './NeckSoundCheck.module.css';
import { openNeckSoundApp } from '../utils/necksoundApp';

const NeckSoundCheck: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { hospitalId } = useParams();
  const prefix = hospitalId ? `/${hospitalId}` : '';
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, []);

  const handleBack = () => {
    console.log('Back button clicked');
    navigate(`${prefix}/check`);
  };

  const handleStartTest = () => {
    console.log('Start test button clicked, opening NeckSound app');
    if (!openNeckSoundApp()) {
      navigate(`${prefix}/necksound/check/new`);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={handleBack}>
          <ArrowBack />
        </button>
        <span className={styles.headerText}>{t('check_before_1')}</span>
      </div>
      <div className={styles.content}>
          <div className={styles.contentScroll} ref={contentRef}>
            {/* Content goes here */}
          </div>
      </div>
      <button className={styles.startTestButton} onClick={handleStartTest}>
        {t('start_test_button')}
      </button>
    </div>
  );
};

export default NeckSoundCheck; 